export const ORDER_URL = "https://waiterman.ai/currystoryindia/order";
export const BOOK_URL = "https://waiterman.ai/currystoryindia/book";
export const PHONE_DISPLAY = "07 3378 8898";
export const PHONE_TEL = "tel:0733788898";
export const ADDRESS = "3/2 Kirkdale Rd, Chapel Hill QLD 4109";
export const MAPS_EMBED =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3539.068997321033!2d152.9556113!3d-27.5029013!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b9151f1efdbb473%3A0xc3b83984d7a8e8b0!2s3%2F2%20Kirkdale%20Rd%2C%20Chapel%20Hill%20QLD%204109%2C%20Australia!5e0!3m2!1sen!2sau!4v1710000000000!5m2!1sen!2sau";
export const DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=3%2F2+Kirkdale+Rd%2C+Chapel+Hill+QLD+4109";

export const HOURS = [
  { day: "Monday", time: "4:30 PM – 8:30 PM" },
  { day: "Tuesday", time: "4:30 PM – 8:45 PM" },
  { day: "Wednesday", time: "4:30 PM – 8:45 PM" },
  { day: "Thursday", time: "4:30 PM – 8:45 PM" },
  { day: "Friday", time: "4:30 PM – 8:45 PM" },
  { day: "Saturday", time: "4:30 PM – 8:45 PM" },
  { day: "Sunday", time: "4:30 PM – 8:45 PM" },
];

export const IMAGES = {
  hero: "/images/hero-curry.webp",
  tandoor: "/images/storefront.webp",
};

export const DISHES = [
  {
    id: "butter-chicken",
    name: "Authentic Butter Chicken",
    category: "Signature Curries",
    price: "$22.61",
    description:
      "Smoked tandoori chicken simmered in a velvet tomato makhani sauce, cooked slowly with fenugreek and real butter.",
    badge: "Most Popular",
    image: "/images/dish-butter-chicken.webp",
  },
  {
    id: "chicken-malai-tikka",
    name: "Chicken Malai Tikka Kebab",
    category: "Tandoori Starters",
    price: "$14.42",
    description:
      "Tender chicken fillets in a two-cheese saffron cream marinade, charred in the clay tandoor.",
    badge: "Chef Special",
    image:
      "https://images.unsplash.com/photo-1617692855027-33b14f061079?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxnb3VybWV0JTIwaW5kaWFuJTIwZm9vZCUyMGJ1dHRlciUyMGNoaWNrZW4lMjB0aWtrYSUyMG5hYW4lMjByZXN0YXVyYW50JTIwZGlzaHxlbnwwfHx8fDE3ODc1NTY2ODV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "paneer-butter-masala",
    name: "Paneer Butter Masala",
    category: "Vegetarian Curries",
    price: "$18.54",
    description:
      "Fresh cottage cheese simmered in a rich tomato, almond and creamy ginger sauce.",
    badge: "Vegetarian Favourite",
    image:
      "https://images.unsplash.com/photo-1606471191009-63994c53433b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxnb3VybWV0JTIwaW5kaWFuJTIwZm9vZCUyMGJ1dHRlciUyMGNoaWNrZW4lMjB0aWtrYSUyMG5hYW4lMjByZXN0YXVyYW50JTIwZGlzaHxlbnwwfHx8fDE3ODc1NTY2ODV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "garlic-naan",
    name: "Garlic Naan",
    category: "Naan Breads",
    price: "$5.15",
    description:
      "Leavened flatbread baked on the hot clay walls of the tandoor, brushed with garlic butter.",
    badge: "Freshly Baked",
    image: "/images/dish-garlic-naan.webp",
  },
];

export const MENU = [
  {
    id: "meal-deals",
    label: "Meal Deals",
    items: [
      { name: "Dinner Pack", desc: "2 curries, 1 naan bread, 1 entrée, large rice, papadum & raita — choose your curry, naan & entrée", price: "$52.95" },
      { name: "Family Pack", desc: "3 curries, 1 chicken tikka, 1 entrée, 2 naan breads, 3 rice, 2 papadum & 1 raita — choose your curry, naan & entrée", price: "$105.95" },
    ],
  },
  {
    id: "tandoori-starters",
    label: "Tandoori Starters",
    items: [
      { name: "Chicken Malai Tikka 4pcs", desc: "Chicken in two cheese saffron cream marinade", price: "$14.42" },
      { name: "Amritsar Tandoori Chicken (Half)", desc: "Cooked in traditional tandoori marinade", price: "$17.51" },
      { name: "Amritsar Tandoori Chicken (Full)", desc: "Cooked in traditional tandoori marinade", price: "$22.66" },
      { name: "Chicken Reshmi Kebab 4pcs", desc: "Chicken marinated in yogurt, ginger, garlic and milk cream", price: "$14.42" },
      { name: "Kashmiri Seekh Kebab 4pcs", desc: "Skewered lamb mince with secret aromatics", price: "$14.42" },
      { name: "Kesari Chicken Tikka 4pcs", desc: "Boneless chicken in a two cheese saffron cream", price: "$14.16" },
      { name: "Tandoori Prawns 12pcs", desc: "King prawns marinated in yogurt spices", price: "$24.72" },
      { name: "Tandoori Platter", desc: "All mixed kebab, no seafood", price: "$27.55" },
    ],
  },
  {
    id: "kadhai-starters",
    label: "Kadhai Starters",
    items: [
      { name: "Punjabi Veg Samosa 3pcs", desc: "", price: "$8.24" },
      { name: "Mughlai Lamb Samosa 3pcs", desc: "Potato and peas in crispy golden homemade pastry", price: "$9.27" },
      { name: "Mysore Urid Vada 4pcs", desc: "Lentils, onions and curry leaves", price: "$8.24" },
      { name: "Onion Bhajji 4pcs", desc: "Sliced onions in crispy chickpea batter", price: "$8.24" },
      { name: "Bombay Potato Bonda 4pcs", desc: "Golden battered masala mashed potato", price: "$8.24" },
      { name: "Kastoori Prawn Pakoras 4pcs", desc: "Cooked in fenugreek tempura batter till golden brown", price: "$13.39" },
      { name: "Chicken 65 (8pcs)", desc: "Traditional South Indian deep fried", price: "$14.42" },
      { name: "Mixed Platter for 2", desc: "Punjabi veg samosa, onion bhaji, bombay potato bonda & mysore urid vada", price: "$20.60" },
      { name: "Eggplant Pakora 4pcs", desc: "", price: "$8.24" },
    ],
  },
  {
    id: "veg-curries",
    label: "Vegetarian Curries",
    note: "All mains served with a small plain rice",
    items: [
      { name: "Aloo Baingan Bagarey", desc: "Rich & spicy eggplant and potato curry with aromatic spices, curry leaves, onions & tomato", price: "$17.25" },
      { name: "Subzi Malai Bahar", desc: "A medley of vegetables cooked in a rich creamy coconut sauce", price: "$17.25" },
      { name: "Pumpkin, Chickpea & Spinach Salan", desc: "Butternut pumpkin tempered with mustard seeds & curry leaves, cooked with chickpeas and spinach", price: "$17.25" },
      { name: "Dahl Makhni", desc: "Dahl cooked in a rich tomato, almond and creamy ginger sauce", price: "$17.25" },
      { name: "Dahl Palak", desc: "Dahl cooked with spinach and aromatic spices", price: "$17.25" },
      { name: "Subzi Dahl", desc: "Dahl cooked with vegetables and tomato with aromatic spices", price: "$17.25" },
      { name: "Eggplant Pasanda", desc: "Eggplant slices stuffed with potato and paneer, simmered in a rich creamy almond sauce", price: "$19.31" },
      { name: "Aloo Gobi", desc: "Potato & cauliflower florets pan-fried with ginger, chillies, fresh coriander, spices and tomatoes", price: "$17.25" },
      { name: "Tadka Dahl", desc: "Traditional tempered dahl with garlic, chillies, onions, tomatoes, curry leaves & mustard seeds", price: "$17.25" },
      { name: "Channa Masala", desc: "", price: "$17.25" },
      { name: "Palak Paneer", desc: "Cottage cheese cubes in a spinach and aromatic spices curry", price: "$18.54" },
      { name: "Paneer Muttar", desc: "Cottage cheese cooked with peas in a rich onion and tomato sauce", price: "$18.28" },
      { name: "Bombay Aloo", desc: "Potato cubes & peas pan-fried with ginger, garlic and spices with a tomato onion sauce", price: "$17.25" },
      { name: "Paneer Makhani", desc: "Cottage cheese cubes in a rich tomato, almond creamy ginger sauce", price: "$18.54" },
    ],
  },
  {
    id: "favourites",
    label: "Indian Favourites",
    note: "All mains served with a small plain rice",
    items: [
      { name: "Butter Chicken", desc: "", price: "$22.61" },
      { name: "Mango Chicken", desc: "Boneless chicken cooked in chef's special spiced creamy sauce", price: "$20.34" },
      { name: "Goat Curry", desc: "Goat on the bone cooked in traditional South Indian style", price: "$21.37" },
      { name: "Goat Pepper Masala", desc: "Goat on the bone cooked in onion, ginger & ground pepper, simmered dry", price: "$21.37" },
      { name: "Mollie Prawn", desc: "Cooked with our own speciality, light spices and creamy coconut milk", price: "$23.43" },
      { name: "Mollie Fish", desc: "Cooked with our own speciality, light spices and creamy coconut milk", price: "$23.43" },
      { name: "Masala Lamb", desc: "Meat cooked with capsicum, onion, tomato and herbs", price: "$21.37" },
      { name: "Masala Beef", desc: "Meat cooked with capsicum, onion, tomato and herbs", price: "$21.37" },
      { name: "Lamb Shank", desc: "", price: "$30.85" },
      { name: "Pepper Chicken Dry", desc: "", price: "$24.67" },
      { name: "Madras Fish Curry", desc: "", price: "$25.70" },
      { name: "Gobi Manchurian", desc: "", price: "$23.64" },
      { name: "Ginger Chicken", desc: "", price: "$24.67" },
      { name: "Chilli Chicken", desc: "", price: "$24.67" },
      { name: "Vindaloo Curry", desc: "", price: "$20.60" },
    ],
  },
  {
    id: "designer-curries",
    label: "Designer Curries",
    note: "All mains served with a small plain rice",
    items: [
      { name: "Korma Flavour Curry", desc: "Creamy yellow sweet and mild onion and almond sauce", price: "$17.25" },
      { name: "Achaar Flavour Curry", desc: "Aromatic sauce made with pickling spices, tomato, onions, chillies and yoghurt", price: "$17.25" },
      { name: "Balti Flavour Curry", desc: "Onion, chillies, tomato, capsicum and cumin sauce — medium spicy", price: "$17.25" },
      { name: "Chettinad Flavour Curry", desc: "Hot & spicy creamy sauce made with peppercorns, chillies & coconut", price: "$17.25" },
      { name: "Dhansak Flavour Curry", desc: "Lentils and vegetables cooked with fresh herbs, onions, tomato and spices", price: "$17.25" },
      { name: "Goan Flavour Curry", desc: "Spicy coconut sauce flavoured with tomato, tamarind and red chillies", price: "$17.25" },
      { name: "Jalfrezi Flavour Curry", desc: "Stir fried with vegetables and sauce", price: "$17.25" },
      { name: "Madras Flavour Curry", desc: "Diced meat cooked with medium spices, coconut milk & herbs", price: "$17.25" },
      { name: "Makhni Flavour Curry", desc: "Creamy tomato, ginger and almond sauce — mild", price: "$17.25" },
      { name: "Nilgiri Flavour Curry", desc: "Flavoursome sauce made with fresh shallots, mint, coriander and green chillies", price: "$17.25" },
      { name: "Rajasthani Flavour Curry", desc: "Flavoured with fennel, thyme, black pepper and mustard", price: "$17.25" },
      { name: "Rogan Josh Flavour Curry", desc: "Made with fried onions, ground spices, tomato and herbs", price: "$17.25" },
      { name: "Saagwala Flavour Curry", desc: "Spinach, tomato, onion, garlic and fresh herbs", price: "$17.25" },
      { name: "Tikka Masala Flavour Curry", desc: "Rich tomato and cream sauce with sliced capsicums, onion and herbs", price: "$17.25" },
      { name: "Vindaloo Flavour Curry", desc: "Hot and spicy sauce made with red chillies, cumin, vinegar and tomato", price: "$17.25" },
    ],
  },
  {
    id: "naan",
    label: "Naan Breads",
    items: [
      { name: "Butter Kulcha", desc: "", price: "$4.38" },
      { name: "Roti Naan", desc: "", price: "$4.63" },
      { name: "Plain Naan", desc: "", price: "$4.63" },
      { name: "Paneer Spinach Naan", desc: "", price: "$4.89" },
      { name: "Cheese & Garlic Naan", desc: "", price: "$4.89" },
      { name: "Garlic Naan", desc: "", price: "$5.15" },
      { name: "Peshwari Naan", desc: "", price: "$5.67" },
      { name: "Potato Naan", desc: "", price: "$5.67" },
      { name: "Tasty Cheese Naan", desc: "", price: "$5.67" },
      { name: "Punjabi Naan", desc: "", price: "$5.67" },
      { name: "Butter Naan", desc: "", price: "$6.18" },
      { name: "Spinach Naan", desc: "", price: "$6.70" },
      { name: "Chicken & Cheese Naan", desc: "", price: "$6.70" },
    ],
  },
  {
    id: "rice-biryani",
    label: "Rice & Biryani",
    items: [
      { name: "Jasmin Rice", desc: "", price: "$5.15" },
      { name: "Coconut Rice", desc: "", price: "$8.24" },
      { name: "Chicken Biryani", desc: "", price: "$24.67" },
      { name: "Chicken 65 Biryani", desc: "", price: "$24.67" },
      { name: "Goat Biryani", desc: "", price: "$25.70" },
      { name: "Lamb Biryani", desc: "", price: "$25.70" },
    ],
  },
  {
    id: "desserts",
    label: "Desserts",
    items: [
      { name: "Gulab Jamun (2)", desc: "Milk dumplings in sugar syrup", price: "$3.86" },
      { name: "Rasagula Sweet", desc: "", price: "$3.86" },
      { name: "Mango Kulfi", desc: "Homemade mango ice-cream", price: "$3.86" },
    ],
  },
  {
    id: "accompaniments",
    label: "Accompaniments",
    items: [
      { name: "Mango Chutney", desc: "", price: "$1.80" },
      { name: "Lime Pickle", desc: "", price: "$1.80" },
      { name: "Mixed Pickle", desc: "", price: "$1.80" },
      { name: "Cucumber & Yoghurt Raita", desc: "", price: "$2.83" },
      { name: "Papadums 4pcs", desc: "", price: "$1.80" },
    ],
  },
  {
    id: "drinks",
    label: "Drinks",
    items: [
      { name: "All Can Drinks", desc: "", price: "$3.09" },
      { name: "Mango Lassi", desc: "", price: "$7.21" },
      { name: "Rose Lassi", desc: "", price: "$7.21" },
    ],
  },
];

export const TESTIMONIALS = [
  {
    name: "Sarah M.",
    suburb: "Chapel Hill",
    text: "The butter chicken here is honestly the best we've had in Brisbane. Rich, silky and full of flavour. Ordering online is so easy and it's always ready on time.",
    rating: 5,
  },
  {
    name: "James T.",
    suburb: "Kenmore",
    text: "Beautiful little restaurant with genuinely warm service. The garlic naan comes out fresh from the tandoor and the malai tikka just melts in your mouth.",
    rating: 5,
  },
  {
    name: "Priya R.",
    suburb: "Indooroopilly",
    text: "Finally, authentic Indian food close to home. The spices taste fresh-ground and the paneer butter masala is restaurant-quality comfort food. Highly recommend.",
    rating: 5,
  },
  {
    name: "Michael K.",
    suburb: "Fig Tree Pocket",
    text: "Booked a table for a family dinner — the staff looked after us brilliantly and every dish was a hit. Our new local favourite for Friday night curry.",
    rating: 5,
  },
];
